import { Link } from 'react-router-dom';

/**
 * SmartAlertsPanel — Condensed alerts display.
 * Renders Critical and Warning as separate grid children (no wrapper div).
 * Parent grid controls the 3-column layout.
 */
export default function SmartAlertsPanel({ alerts }) {
  const active = alerts?.active || [];
  const history = alerts?.history || [];

  // Combine and deduplicate
  const allAlerts = [...active, ...history];
  const critical = allAlerts.filter(a => a.severity === 'critical');
  const warnings = allAlerts.filter(a => a.severity === 'warning');

  if (critical.length === 0 && warnings.length === 0) return null;

  return (
    <>
      {/* Critical alerts — own grid cell */}
      {critical.length > 0 && (
        <Link
          to="/alerts?severity=critical"
          className="bg-red-500/10 border border-red-500/20 rounded-xl p-3 hover:bg-red-500/15 transition-colors group min-w-0"
        >
          <div className="flex items-center gap-2 mb-2">
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-red-500/20 text-red-400 text-xs font-bold shrink-0">
              {critical.length}
            </span>
            <span className="text-sm font-semibold text-red-400">Critical</span>
            <svg className="w-3.5 h-3.5 text-red-500/40 ml-auto group-hover:text-red-400 transition-colors shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
          {critical.slice(0, 2).map((alert, i) => (
            <p key={alert.id || i} className="text-xs text-red-300/80 truncate mb-0.5">
              {alert.message || alert.title}
            </p>
          ))}
        </Link>
      )}

      {/* Warning alerts — own grid cell */}
      {warnings.length > 0 && (
        <Link
          to="/alerts?severity=warning"
          className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-3 hover:bg-amber-500/15 transition-colors group min-w-0"
        >
          <div className="flex items-center gap-2 mb-2">
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-amber-500/20 text-amber-400 text-xs font-bold shrink-0">
              {warnings.length}
            </span>
            <span className="text-sm font-semibold text-amber-400">Warnings</span>
            <svg className="w-3.5 h-3.5 text-amber-500/40 ml-auto group-hover:text-amber-400 transition-colors shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
          {warnings.slice(0, 2).map((alert, i) => (
            <p key={alert.id || i} className="text-xs text-amber-300/80 truncate mb-0.5">
              {alert.message || alert.title}
            </p>
          ))}
        </Link>
      )}
    </>
  );
}
